import React, { Component } from "react";
import axios from "axios";
import Constants from "../App/Variables/Constant";
import { Link, Navigate } from "react-router-dom";
import init from "../helpers/WindowToken";
import {
  Button,
  Container,
  Grid,
  Snackbar,
  TextField,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { renderHTML } from "react-render-html";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import SunEditor from "suneditor-react";
// import "suneditor/dist/css/suneditor.min.css";
let auth = localStorage.getItem("accessToken");

export default class UpdateFaq extends Component {
  state = {
    loading: false,
    question: "",
    faqId: "",
    description: "",
    answer: "",
    notification: false,
    type: "",
    faqId: "",
    message: "",
    redirect: false,
    error: false,
    textChange: false,
  };
  componentDidMount() {
    let id = window.location.pathname.split("/")[3];
    this.setState(
      {
        faqId: id,
      },
      () => {
        // this.getFaq();
        console.log(this.state.faqId);
        if (init() === "success") {
          axios
            .get(Constants.getUrls.getFaq + this.state.faqId, {
              headers: { Authorization: `Bearer ${auth}` },
            })
            .then((resp) => {
              console.log(resp);
              this.setState(
                {
                  question: resp.data.faq.question,
                  description: resp.data.faq.answer,
                  type: resp.data.faq.type,
                },
                () => {
                  console.log(this.state.description);
                }
              );
            });
        }
      }
    );
  }
  // getFaq = () => {
  //   // let id = window.location.pathname.split("/")[3];
  //   // this.setState({
  //   //   faqId: id,
  //   // });
  // };
  // handleChangeDesc(content) {
  //   // console.log(content); //Get Content Inside Editor
  //   this.setState({
  //     description: content,
  //   });
  // }
  handleChange = (e) => {
    if (e.target.name === "question") {
      this.setState({
        error: false,
      });
    }
    this.setState({
      [e.target.name]: e.target.value,
      textChange: true,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    if (init() === "success") {
      let auth = localStorage.getItem("accessToken");
      // if (
      //   this.state.image === null ||
      //   this.state.image === "" ||
      //   this.state.title === null ||
      //   this.state.title === "" ||
      //   this.state.description === null ||
      //   this.state.description === ""
      // ) {
      //   this.setState({
      //     notification: true,
      //     message: "Check your input.It cant be null or empty",
      //     loading: false,
      //   });
      //   setTimeout(
      //     () =>
      //       this.setState({ notifcation: false, message: "", loading: false }),
      //     2000
      //   );
      //   setTimeout(() => this.getTestimonial(), 3000);
      // } else {

      let fd = {
        question: this.state.question,
        answer: this.state.description,
        type: this.state.type,
      };

      // if(this.state.textChange===false){
      //   this.setState({notification:true,
      //   message:"nothing to change here"})
      //   setTimeout(() => {
      //     this.setState({notification:false,
      //       loading:false,
      //       redirect:true
      //     })
      //   }, 2000);
      // } else {
      axios
        .put(Constants.putUrls.updateFaq + this.state.faqId, fd, {
          headers: {
            // "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${auth}`,
          },
        })
        .then((resp) => {
          // axios.post("http://localhost:8081/createStocks", stockLoad).then((resp) => {
          // console.log(this.state.image);
          this.setState({
            loading: false,
            notification: true,
            message: resp.data.message,
          });
          if (resp.data.message === undefined || resp.data.message === null) {
            // console.log(resp);
            if (resp.data.errors.msg) {
              this.setState({
                message: resp.data.errors.msg,
              });
            } else {
              this.setState({
                message: "unknown error",
              });
            }
          }
          if (
            resp.data.message ===
            `question already exist with the name ${this.state.question}`
          ) {
            this.setState({
              error: true,
            });
          }
          setTimeout(() => {
            this.setState({
              // title: "",
              // image: "",

              // description: "",
              notification: false,
            });
            // fd.delete("title", this.state.title);
            // fd.delete("description", this.state.description);
            // fd.delete("image", this.state.image);
          }, 2000);

          if (resp.data.message === "Updated Successfully") {
            setTimeout(() => {
              this.setState({
                redirect: true,
              });
            }, 3000);
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            notification: true,
            message: "some error occured check your console",
          });
          setTimeout(() => {
            this.setState({
              // title:"",
              //   image:"",
              //   description:"",
              //   location:"",
              notification: false,
              message: "",
              loading: false,
            });
          }, 2000);
          // window.location.reload();
          // setTimeout(() => {
          //   this.setState({
          //     title: "",
          //     image: "",
          //     description: "",
          //     notification: true,
          //     loading: false,
          //     message: "error",
          //   });
          //   fd.append("title", this.state.title);
          //   fd.append("description", this.state.description);
          //   fd.append("image", this.state.image);
          // }, 2000);
          // setTimeout(() => {
          //   this.getFaq();
          // }, 3000);
        });
      // }
      // }
    }
  };
  render() {
    return (
      <Container maxWidth="xl">
        {this.state.redirect && <Navigate to="/faq" replace={true} />}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="h6"> Faq </Typography>
          </Grid>
        </Grid>
        {this.state.notification ? (
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={true}
            autoHideDuration={5000}
            color="green"
            message={this.state.message}
          ></Snackbar>
        ) : null}
        <div
          style={{
            background: "#5b5757",
            padding: "20px",
            borderRadius: "10px",
            // color: rgba(0, 0, 0, 0.87);
            width: "100%",
            border: "0",
            display: "flex",
            position: "relative",
            fontSize: ".875rem",
            minWidth: "0",
            wordWrap: " break-word",
            /* background: #FFF; */
            boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
            marginTop: "30px",
            borderRadius: "6px",
            marginBottom: "30px",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <div
            style={{
              background:
                "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
              boxShadow:
                " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
              float: "left",
              padding: "15px",
              marginTop: "-43px",
              marginRight: "15px",
              borderRadius: "3px",
              backgroundColor: "#999",
              width: "6%",
              height: "60px",
              marginBottom: "25px",
              textAlign: "center",
            }}
          >
            <EditIcon />
          </div>
          <form onSubmit={this.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item sm={8}>
                <TextField
                  name="question"
                  error={this.state.error}
                  id={this.state.error ? "outlined-error" : "outlined-basic"}
                  label={this.state.error ? "Error" : "Question"}
                  size="medium"
                  variant="outlined"
                  multiline
                  maxRows={4}
                  required={true}
                  type="text"
                  onChange={this.handleChange}
                  style={{ width: "100%" }}
                  value={this.state.question}
                />
              </Grid>
              <Grid item sm={4}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="Id">Type</InputLabel>

                  <Select
                    name="type"
                    labelId="Id"
                    id="Id"
                    value={this.state.type}
                    label="User Type"
                    onChange={this.handleChange}
                  >
                    <MenuItem value="buyer">Buyer</MenuItem>
                    <MenuItem value="seller">Seller</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <div style={{ color: "black", marginTop: "20px" }}>
              <label style={{ color: "white" }}>description:</label>

              <CKEditor
                className="ckeditor"
                // value={this.state.description}
                editor={ClassicEditor}
                onChange={(event, editor) => {
                  // console.log(event)
                  const data = editor.getData();  
                  this.setState({
                    description: data,
                  });
                }}
                data={this.state.description}
              />
              {/* <CKEditor
                    editor={ ClassicEditor }
                    data="<p>Hello from CKEditor 5!</p>"
                    onReady={ editor => {
                        // You can store the "editor" and use when it is needed.
                        console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                        const data = editor.getData();
                        console.log( { event, editor, data } );
                    } }
                    onBlur={ ( event, editor ) => {
                        console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                        console.log( 'Focus.', editor );
                    } }
                /> */}

              {/* <CKEditor
                editor={ClassicEditor}
                data={this.state.answer}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  // console.log({ event, editor, data });
                  this.setState({
                    answer: data,
                  });
                }}
              /> */}
            </div>

            {/* <div style={{ color: "black" }}>
              <SunEditor
                // setContents={this.state.description}
                defaultValue={this.state.description}
                onChange={this.handleChangeDesc.bind(this)}
                // width="50%"
                setOptions={{
                  buttonList: [
                    ["undo", "redo"],
                    ["font", "fontSize"],
                    // ['paragraphStyle', 'blockquote'],
                    [
                      "bold",
                      "underline",
                      "italic",
                      "strike",
                      "subscript",
                      "superscript",
                    ],
                    // ["fontColor", "hiliteColor"],
                    ["align", "list", "lineHeight"],
                    ["outdent", "indent"],
                    ["table", "horizontalRule", "link", "image", "video"],
                    // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                    // ['imageGallery'], // You must add the "imageGalleryUrl".
                    // ["fullScreen", "showBlocks", "codeView"],
                    ["preview", "print"],
                    ["removeFormat"],
                    // ['save', 'template'],
                    // '/', Line break
                  ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                  defaultTag: "div",
                  minHeight: "300px",
                  showPathLabel: false,
                  // font: sortedFontOptions
                }}
                // setContents={renderHTML(this.state.description)}
              />
            </div> */}

            <br />
            <Button
              variant="contained"
              type="submit"
              size="medium"
              color="primary"
              style={{
                marginRight: "20px",

                marginTop: "35px",
              }}
            >
              {this.state.loading ? "Updating.." : "Update "}
            </Button>
            <Link
              to={{
                pathname: "/faq",
              }}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="contained"
                type="submit"
                color="secondary"
                style={{ marginRight: "20px", marginTop: "35px" }}
              >
                Cancel
              </Button>
            </Link>
          </form>
        </div>
      </Container>
    );
  }
}
